const { PAYPAL_API_URLS } = require('./../paypal-smart-buttons/paypal-constants');
const request = require('./../paypal-smart-buttons/request');

const updateOrder = (data) => {
	return request(PAYPAL_API_URLS.updateOrder, 'POST', data)
		.then((response) => {
			return response;
		})
		.catch(() => {
			return;
		});
};

module.exports = updateOrder;
